module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasPhotos) ? _c('div', {
    staticClass: "page-organizations-card-photo"
  }, _vm._l((_vm.photos), function(photo, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": photo
      }
    })
  }), 0) : _c('center', [_c('b', [_vm._v("К СОЖАЛЕНИЮ, ПО ДАННОМУ ОРГАНИЗАТОРУ НЕТ НИКАКИХ ФОТОГРАФИЙ ИЛИ ИНЫХ ГРАФИЧЕСКИХ МАТЕРИАЛОВ.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523feb1d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/card/photos/component.vue
// module id = 0f30aa11388b034a2677
// module chunks = 1